import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { createElement } from 'react';
import { CreateSVG } from "../lib/index.js";
function SvgIconFullBoardMeal(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createElement(CreateSVG, _objectSpread(_objectSpread({}, props), {}, {
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement("svg", _extends({
        id: "Icon-full_board_meal_svg__stroke",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 52 52",
        "aria-labelledby": titleId
      }, props), title ? /*#__PURE__*/React.createElement("title", {
        id: titleId
      }, title) : null, /*#__PURE__*/React.createElement("path", {
        d: "M7,39H45a.99974.99974,0,0,0,1-1c0-12.03436-6.86914-21.06262-16.73267-22.706a4,4,0,1,0-6.53466,0C12.86914,16.93738,6,25.96564,6,38A.99974.99974,0,0,0,7,39ZM24,13a2,2,0,1,1,2,2A2.00229,2.00229,0,0,1,24,13Zm2,4c10.31055,0,17.5957,8.17188,17.9834,20H8.0166C8.4043,25.17188,15.68945,17,26,17Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M49,38a.99974.99974,0,0,0-1,1v1.00049A1.00057,1.00057,0,0,1,47,41H5a1.00057,1.00057,0,0,1-1-.99951V39a1,1,0,0,0-2,0v1.00049A3.00317,3.00317,0,0,0,5,43H47a3.00317,3.00317,0,0,0,3-2.99951V39A.99974.99974,0,0,0,49,38Z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M26,19a1,1,0,0,0,0,2c4.67383,0,10.11328,2.86084,11.00977,9.1416A1.00028,1.00028,0,0,0,37.999,31a1.01137,1.01137,0,0,0,.14258-.01025.99987.99987,0,0,0,.84863-1.13135C37.92383,22.398,31.50879,19,26,19Z"
      }));
    }
  }));
}
export default SvgIconFullBoardMeal;